var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{style:({ width: _vm.widget.options.width }),attrs:{"filterable":"","disabled":_vm.disabled,"clearable":_vm.widget.options.clearable,"placeholder":_vm.widget.options.placeholder,"options":_vm.widget.options.remoteOptions,"show-all-levels":_vm.widget.options.showAllLevels,"props":{
    multiple: _vm.widget.options.multiple,
    checkStrictly: _vm.widget.options.checkStrictly,
    label: _vm.widget.options.props.label,
    value: _vm.widget.options.props.value,
  }},on:_vm._d({},[_vm.event,_vm.eventMethod]),model:{value:(_vm.casValue),callback:function ($$v) {_vm.casValue=$$v},expression:"casValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }